import { MyAccountSettings } from './MyAccountSettings';

export default MyAccountSettings;
